// src/pages/MenuPage.jsx
import React, { useState } from "react";
import { menuItems } from "../data/menuData";
import MenuGrid from "../components/MenuGrid";

export default function MenuPage() {
  const categories = ["All", "Nepali", "Curries", "Biryani", "Appetizers", "Tandoori"];

  const [activeCat, setActiveCat] = useState("All");

  const filteredItems =
    activeCat === "All"
      ? menuItems
      : menuItems.filter((item) => item.category === activeCat);

  return (
    <div className="menu-page">

      <h1 className="menu-title">Our Menu</h1>

      {/* Category Filters */}
      <div className="menu-categories">
        {categories.map((cat) => (
          <button
            key={cat}
            className={activeCat === cat ? "cat-btn active" : "cat-btn"}
            onClick={() => setActiveCat(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* Grid */}
      <MenuGrid items={filteredItems} />
    </div>
  );
}
